import { TestStep } from './../../../modules/test-step-table/models/test-step.model';
import { Component, Input, OnInit } from '@angular/core';
import { EditPanelTestStepHelperService } from '../../../services/edit-panel-test-step.helper';
import { BlueprintStore } from '../../../../../services/stores/blueprint.store';
import { WorkspaceStore } from '../../../../../services/stores/workspace.store';
import { ExportHelper } from '../../../../../services/helpers/export-helper';

@Component({
  selector: 'app-test-summary-table',
  templateUrl: './test-summary-table.component.html',
  styleUrls: ['./test-summary-table.component.css'],
  standalone: false,
})
export class TestSummaryTableComponent implements OnInit {
  @Input() inputTableData: TestStep[] = [];

  testStepData = {};

  first = 0;
  rows = 10;

  selectedTestSteps: any;
  cols: any[] = [];
  exportColumns: any[] = [];
  numberOfFiles: number = 0;

  constructor(
    private blueprintStore: BlueprintStore,
    private workspaceStore: WorkspaceStore,
    private editPanelTestStepHelper: EditPanelTestStepHelperService,
    private exportHelper: ExportHelper,
  ) {}

  ngOnInit() {}


  next() {
    this.first = this.first + this.rows;
  }

  prev() {
    this.first = this.first - this.rows;
  }

  reset() {
    this.first = 0;
  }

  isLastPage(): boolean {
    return this.inputTableData ? this.first === this.inputTableData.length - this.rows : true;
  }

  isFirstPage(): boolean {
    return this.inputTableData ? this.first === 0 : true;
  }

  getStatusColor(data: any): string {
    const workspaceBlueprintId = this.workspaceStore?.selectedWorkspaceInstance?.bluePrintId;
    const selectedBlueprintId = this.blueprintStore?.selectedBluePrint?.id;
    const bluePrintId = workspaceBlueprintId || selectedBlueprintId;
    const workspace = bluePrintId ? { bluePrintId } : undefined;
    const style = this.editPanelTestStepHelper.getTestStatusStyle(data?.teststatus, workspace);
    return style?.['border-color'] || style?.['text-color'] || style?.['fill-color'] || '#c1cfe9';
  }
}
